import { Center } from './Center.model'
import { RefinementList } from '@/domain/search/types'
export type SearchState = {
  page?: number
  configure?: {
    facetingAfterDistinct?: boolean
    highlightPreTag?: string
    highlightPostTag?: string
    filters?: string
    hitsPerPage?: number
    page?: number
    aroundRadius?: number | string
    aroundPrecision?: number | string
    aroundLatLng?: string
    optionalFilters?: string[]
    facetFilters?: string[]
    ranking?: string[]
  }
  locationName?: string
  menu?: {}
  refinementList?: RefinementList
  nbHits?: number
}

export type CustomeSearchState = {
  aroundLatLng?: string
  locationName?: string
  locationType?: string
  customLocationRadiusInMiles?: string
} & SearchState

export type FacetList = RefinementList
type Facet = {
  name: keyof FacetList
  data: {
    [key: string]: number
  }
  exhaustive: boolean
}

export interface SearchResults {
  hits: Center[]
  _rawResults: Partial<[Center][]>[]
  _state: SearchState
  facets: Facet[]
  nbHits?: number
  nbPages?: number
  page?: number
  processingTimeMS?: number
  query?: string
  index?: string | number
  disjunctiveFacets?: string[]
  hierarchicalFacets?: string[]
}
export interface InstantSearch {
  searchResults: SearchResults
  searchState: SearchState
}

export type ValueState<RefinementList> = {
  [Property in keyof RefinementList]?: Partial<RefinementList>[Property]
} & {
  taxonomy: string
  value: string[]
  label: string
}

export enum TaxonomyFilters {
  locations = 'locations',
  what_we_treat = 'what_we_treat',
  accepted_insurance = 'accepted_insurance',
  price = 'price',
  treatment_services = 'treatment_services',
  treatment_therapies = 'treatment_therapies',
  amenities = 'amenities',
  who_we_treat = 'who_we_treat',
  special_considerations = 'special_considerations',
  treatment_method = 'treatment_method',
  setting = 'setting',
  activities = 'activities',
  languages = 'languages'
}
